import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import { onCLS, onFCP, onLCP, onTTFB, onINP } from 'web-vitals'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

// Web Vitals reporting
function sendToAnalytics(metric) {
  // You can send metrics to your analytics endpoint here
  // For now, we'll just log them in development
  if (import.meta.env.DEV) {
    console.log(metric)
  }
}

// Register all web vitals
// Note: onFID was deprecated in v5, replaced by onINP (Interaction to Next Paint)
onCLS(sendToAnalytics)
onFCP(sendToAnalytics)
onLCP(sendToAnalytics)
onTTFB(sendToAnalytics)
onINP(sendToAnalytics)

